import { createEffect, createRoot } from "solid-js"
import { type Color, type MeshBasicMaterial, type MeshLambertMaterial, type MeshStandardMaterial } from "three"

// narrow down to the materials this file should be concerned with
type MaterialUnion = MeshBasicMaterial | MeshStandardMaterial | MeshLambertMaterial

export default function bindReactiveColorToMaterial<T extends MaterialUnion>(
  material: T,
  fn: (material: T) => Color | number,
): void {
  createRoot((disposeRoot) => {
    createEffect(() => {
      // console.log('bindReactiveColorToMaterial.effect')
      material.color.set(fn(material))
      // not necessary for only changing color
      // material.needsUpdate = true
    })
    material.addEventListener('dispose', disposeRoot)
  })
}
